import L from "leaflet";

export const VenueLocationIcon = L.icon({
  iconUrl: require("../../assets/location_info.png"),
  iconSize: [38, 53]
  // iconSize: new L.Point(60, 75),
});
